import { Badge } from '@/components/ui/badge';
import { formatRelative } from '@/lib/time';
import { Thumbnail } from './Thumbnail';

// Field names mirror the submissions Firestore collection.
export type Submission = {
  id: string;
  school_name?: string;
  sportType?: string;
  fundraiserName?: string;
  status?: string;
  createdAt?: string;
  rep_last_action_at?: string;
  tier1LogoPath?: string | null;
};

const statusVariant: Record<string, { label: string; className: string }> = {
  pending_worker_review:  { label: 'Pending',     className: 'bg-bg text-muted' },
  awaiting_rep_decision:  { label: 'Awaiting Rep',className: 'bg-primary/10 text-primary' },
  changes_requested:      { label: 'Revision',    className: 'bg-warning/10 text-warning' },
  final_approved:         { label: 'Approved',    className: 'bg-success/10 text-success' },
  proof_approved:         { label: 'Approved',    className: 'bg-success/10 text-success' },
  order_pending:          { label: 'Order Pend.', className: 'bg-primary/10 text-primary' },
  ordered:                { label: 'Ordered',     className: 'bg-success/10 text-success' },
  artwork_pending:        { label: 'Artwork',     className: 'bg-primary/10 text-primary' },
  cancelled:              { label: 'Cancelled',   className: 'bg-bg text-muted' },
};
const FALLBACK_VARIANT = { label: 'Unknown', className: 'bg-bg text-muted' };

export function SubmissionRow({ s, onClick }: { s: Submission; onClick: () => void }) {
  const v = statusVariant[s.status ?? ''] ?? FALLBACK_VARIANT;
  const lastSeen = s.rep_last_action_at || s.createdAt;
  return (
    <button
      onClick={onClick}
      className="flex w-full items-center gap-3 border-b border-divider px-3 py-2 text-left hover:bg-bg/60 last:border-b-0"
    >
      <Thumbnail path={s.tier1LogoPath} alt="logo" className="h-8 w-8" />
      <span className="font-mono text-[10px] text-subtle w-20 shrink-0">{s.id.slice(0, 12)}</span>
      <span className="flex-1 truncate text-[12px]">
        {s.school_name || s.fundraiserName || 'Unknown'}{s.sportType ? ` · ${s.sportType}` : ''}
      </span>
      <Badge className={v.className}>{v.label}</Badge>
      <span className="w-12 shrink-0 text-right text-[11px] text-muted">
        {lastSeen ? formatRelative(lastSeen) : ''}
      </span>
    </button>
  );
}
